import React from 'react'
import type { BetLoopProfile } from '@core/Areas/BetLoop/types'

export const ProfileContext = React.createContext<
  | {
      isOnProfilePage: false
      profilePageId?: never
      scrollToDefaultProfileState?: never
    }
  | {
      isOnProfilePage: true
      profilePageId: BetLoopProfile['id']
      scrollToDefaultProfileState: () => void
    }
>({ isOnProfilePage: false })
